import React from 'react';
import { CellPlugin } from '@react-page/editor';
// (Optional) Use a Material-UI icon for the plugin toolbar button:
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'; 

// Data shape for the plugin state
interface FilePluginData extends Record<string, unknown> {
  url?: string;
  name?: string;
}

// Signature of the upload function provided by the user
export type FileUploadFunction = (file: File) => Promise<{ url: string }>;

// Factory to create the file upload plugin
export function createFilePlugin(uploadFile?: FileUploadFunction): CellPlugin<FilePluginData> {
  const filePlugin: CellPlugin<FilePluginData> = {
    id: 'file-upload',  
    title: 'File',  
    description: 'Upload a file and insert a download link.',  
    icon: <InsertDriveFileIcon />,  // Icon displayed in toolbar (adjust as needed)
    version: 1,

    // Renderer: displays the link in the editor content (both edit and read-only modes)
    Renderer: ({ data }) => {
      if (!data.url) return <em>No file selected</em>;
      return (
        <a href={data.url} target="_blank" rel="noopener noreferrer">
          {data.name || 'Download file'}
        </a>
      );
    },

    // Controls: use a custom React component for the file upload interface
    controls: {
      type: 'custom',
      Component: ({ data, onChange }) => {
        // Handler for file selection
        const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
          const file = event.target.files?.[0];
          if (file && uploadFile) {
            // Call the provided upload function and get the URL
            const { url } = await uploadFile(file);
            // Update plugin data with the new file URL and name
            onChange({ ...data, url: url, name: file.name });
            // (You might handle upload errors with try/catch and show a message if needed)
          }
        };

        return (
          <div>
            {/* If a file is already uploaded, show the link and an option to replace it */}
            {data.url ? (
              <div>
                <strong>File:</strong>{' '}
                <a href={data.url} target="_blank" rel="noopener noreferrer">
                  {data.name || 'Download file'}
                </a>
              </div>
            ) : (
              <div><em>No file selected.</em></div>
            )}
            {/* File input for uploading or replacing the file */}
            <input type="file" onChange={handleFileChange} />
          </div>
        );
      }
    }
  };
  return filePlugin;
}
